import {SortingOptionSelectedEvent} from "./events";
import {EventBus} from "../../../../common/ts/events/EventBus";
import {WhitelabelEvent} from "../../../../common/ts/events/Events"
import tracking from "../../../../common/ts/core/tracking";
import location from "../../../../common/ts/core/location";

const SORTING_INPUT_NAME = 'sorting';

const sortingValueToEventNameMap = new Map([
    ['popularity', 'serp-filter-sort-relevance'],
    ['newest', 'serp-filter-sort-updated'],
    ['price-low', 'serp-filter-sort-price-low'],
    ['price-high', 'serp-filter-sort-price-high'],
])

let eventBus: EventBus;

export function sortingOptionSelectedEventHandler(event: WhitelabelEvent) {
    const {payload: {optionValue, currentUrl}} = event as SortingOptionSelectedEvent;
    const newSortingValue = optionValue ? optionValue : ""
    const url = new URL(currentUrl)

    url.searchParams.set(SORTING_INPUT_NAME, newSortingValue)

    eventBus.emitMany([
        new tracking.TrackAnalyticsEvent({
            name: sortingValueToEventNameMap.get(optionValue!)
        }),
        new location.AssignUrlEvent({url: url.href}),
        new tracking.TrackWebTrackingEvent({
            type: "FiltersUpdated",
            serpUrl: currentUrl,
            filters: {[SORTING_INPUT_NAME]: newSortingValue}
        }),
    ])

}

function init(ev: any = EventBus.getInstance()) {
    eventBus = ev;
    eventBus.subscribe(SortingOptionSelectedEvent.TYPE, sortingOptionSelectedEventHandler);
}

export default {
    init
};
